import {useCallback} from 'react';
import {useSelector, useStore} from 'react-redux';
import {NavBottom} from '~/CreateFabricInvitation/components/NavBottom/NavBottom';
import {navigateToRoute} from '~/CreateFabricInvitation/navigation';
import {selectIsUpsellConfirmed} from '~/CreateFabricInvitation/reducers/modals';
import {isDraft} from '~/common/utils/event_utils';
import {Button} from '~library/atoms/Button';

export const NavButtons = ({eventStatus}) => {
  const store = useStore();
  const eventIsDraft = isDraft(eventStatus);
  const upsellConfirmed = useSelector(selectIsUpsellConfirmed);

  const onClickHandler = useCallback(async () => {
    if (upsellConfirmed) {
      await navigateToRoute('review', store);
    } else {
      await navigateToRoute('exit', store);
    }
  }, [upsellConfirmed, store]);

  if (!eventIsDraft) {
    return (
      <div className="create-flow__form-nav">
        <Button
          className="create-flow__form-nav-done"
          data-qa-id="nav-bottom-done"
          variant="primary"
          size="large"
          type="button"
          onClick={onClickHandler}
        >
          {`${upsellConfirmed ? 'Next: Checkout' : 'Done'}`}
        </Button>
      </div>
    );
  }

  return <NavBottom />;
};
